"use client";

import React from "react";
import { useTranslations } from "next-intl";
import { reportError, installErrorReporting } from "../lib/telemetry";

function ErrorFallback() {
  const t = useTranslations("components");
  return (
    <div className="cgErrorFallback">
      <h2>{t("errorBoundary")}</h2>
      <p>{t("errorBoundaryDesc")}</p>
      <a className="cgBtn cgBtnPrimary" href="/">
        {t("backHome")}
      </a>
    </div>
  );
}

export default class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  constructor(props: { children: React.ReactNode }) {
    super(props);
    if (typeof window !== "undefined") installErrorReporting();
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    reportError({
      message: error.message,
      stack: error.stack ?? info.componentStack ?? "",
      severity: "react",
    });
  }

  render() {
    if (this.state.hasError) {
      return <ErrorFallback />;
    }
    return this.props.children;
  }
}
